module.exports = __webpack_public_path__ + "media/images/riders/MANUEL_FUMIC-6094bb7c8b1829b22fc8343666ee61cb.png";